import axiosInstance from "./api/axiosInstance";

const getDashboardData = async (clientId) => {
  const response = await axiosInstance.get(`goldenbox/dashboard/${clientId}`);
  return response.data;
};

const getAvailableContractsForGoldenBox = async (clientId) => {
  const response = await axiosInstance.get(
    `contract/avaliable-for-golden-box?clientId=${clientId}`
  );
  return response.data;
};

const createGoldenBox = async (createDto) => {
  const response = await axiosInstance.post("goldenbox", createDto);
  return response.data;
};

const requestWithdraw = async (withdrawDto) => {
  const response = await axiosInstance.post(
    "goldenboxwithdraw/request",
    withdrawDto
  );
  return response.data;
};

const getMyWithdraws = async (limit = 10, offset = 0) => {
  const response = await axiosInstance.get(
    `goldenboxwithdraw/my-withdraws?limit=${limit}&offset=${offset}`
  );
  return response.data;
};

const cancelWithdraw = async (withdrawId) => {
  const response = await axiosInstance.post(
    `goldenboxwithdraw/cancel-withdraw/${withdrawId}`
  );
  return response.data;
};

const getClientExtracts = async (descriptionSearch = "", limit = 10, offset = 0) => {
  const params = new URLSearchParams({
    descriptionSearch: descriptionSearch || "",
    limit: limit,
    offset: offset,
  });
  
  const response = await axiosInstance.get(`goldenboxextract/extract-search?${params}`);
  return response.data;
};

export const goldenBoxService = {
  getDashboardData,
  getAvailableContractsForGoldenBox,
  createGoldenBox,
  requestWithdraw,
  getMyWithdraws,
  cancelWithdraw,
  getClientExtracts,
};
